import { render } from "./faqConfigView.vue?vue&type=template&id=73692a54&scoped=true"
import script from "./faqConfigView.vue?vue&type=script&lang=js"
export * from "./faqConfigView.vue?vue&type=script&lang=js"

import "./faqConfigView.vue?vue&type=style&index=0&id=73692a54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73692a54"

export default script